import { faCaretDown, faCaretUp, faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { Button, ButtonProps } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { VisitStatus } from 'src/models/visit/_types';
import { getVisitStatus } from 'src/models/visit/utils';

export const VisitStatusButton = ({ visit, setOpen, open }) => {
  const statusMapping = [
    {
      status: VisitStatus.Registered,
      color: 'secondary',
      icon: undefined,
    },
    {
      status: VisitStatus.Reserved,
      color: 'secondary',
      icon: undefined,
    },
    {
      status: VisitStatus.Completed,
      color: 'success',
      icon: 'check',
    },
    {
      status: VisitStatus.Cancelled,
      color: 'error',
      icon: 'times',
    },
    {
      status: VisitStatus.LateCancelled,
      color: 'error',
      icon: 'times',
    },
  ];

  const currentVisitStatus =
    statusMapping.find((x) => x.status === visit.status) || statusMapping[0];

  return currentVisitStatus.icon ? (
    <Button
      size="small"
      color={currentVisitStatus.color as ButtonProps['color']}
      variant="contained"
      onClick={() => setOpen(true)}
      sx={{ pl: 1 }}
      endIcon={
        <Icon
          sx={{ fontSize: '0.75rem !important' }}
          icon={
            open
              ? faCaretUp
              : faCaretDown
          }
        />
      }
      startIcon={
        <Icon
          sx={{
            fontSize: '1.25rem !important',
          }}
          icon={
            currentVisitStatus.icon === 'times'
              ? faTimesCircle
              : faCheckCircle
          }
        />
      }
    >
      {getVisitStatus(visit) || 'None'}
    </Button>
  ) : (
    <Button
      size="small"
      color={currentVisitStatus.color as ButtonProps['color']}
      variant="contained"
      endIcon={
        <Icon
          sx={{ fontSize: '0.75rem !important' }}
          icon={
            open
              ? faCaretUp
              : faCaretDown
          }
        />
      }
    >
      {getVisitStatus(visit) || 'None'}
    </Button>
  );
};
